import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"ai-search","clipPath":"url(#clip0_365_141)"},"children":[{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M16.75 2.5L17.2697 3.73028L18.5 4.25L17.2697 4.76972L16.75 6L16.2303 4.76972L15 4.25L16.2303 3.73028L16.75 2.5Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15.8027 15.8037L21.106 21.107M15.8027 15.8037C12.8738 18.7327 8.12563 18.7323 5.1967 15.8033C2.26777 12.8744 2.26777 8.12565 5.1967 5.19672C6.53393 3.85949 8.25048 3.13278 10 3.0166M15.8027 15.8037C17.14 14.4664 17.8669 12.7497 17.9831 11","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const AiSearch = Vue.extend<IconProps>({
  name: 'AiSearchIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'ai-search',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default AiSearch;
